import React from 'react';
import cx from "classnames";
import PropTypes from "prop-types"
import {Switch} from 'antd';

const NewSwitch = ({className, label, position, checked, field, form, ...props}) => {

    const classes = cx(
        'new-switch-form',
        checked && 'is-active',
        className
    );

    const handleChange = (checked) => {
        form.setFieldValue(field.name, checked);
    };

    return (
        <div className={classes}>
            <label className="form-field__switch">
                {label && (
                    <div className={`form-field__label ${field.value && 'is-active'}`}>{label}</div>
                )}
                <Switch
                    {...props}
                    checked={field.value}
                    onChange={handleChange}
                    className={'custom-ant-switch'}
                />
                <span className={cx("form-field__status-text", {"is-active": field.value})}>
                    {field.value ? 'ON' : 'OFF'}
                </span>
            </label>

        </div>
    );
};

NewSwitch.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    position: PropTypes.oneOf(["left", "beet"]),
};

NewSwitch.defaultProps = {
    className: null,
    label: null,
    position: 'beet'
};

export default NewSwitch;
